import { render, staticRenderFns } from "./order-detail.vue?vue&type=template&id=5b5e8230&scoped=true&"
import script from "./order-detail.vue?vue&type=script&lang=ts&"
export * from "./order-detail.vue?vue&type=script&lang=ts&"
import style0 from "./order-detail.vue?vue&type=style&index=0&id=5b5e8230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5e8230",
  null
  
)

component.options.__file = "order-detail.vue"
export default component.exports